export default __webpack_public_path__ + "static/media/mobile.c428c9e8.png";